<div *ngIf="_priceWithoutDiscount">
	<span class="sign" *ngIf="_negative">-</span>
	<span class="symbol-totalCostAfterXMonths" *ngIf="_percentage">%</span>
	<span class="value-totalCostAfterXMonths priceWithoutDiscount" *ngIf="_percentage">{{ _priceWithoutDiscount }}</span>
	<span class="value-totalCostAfterXMonths priceWithoutDiscount" *ngIf="!_percentage">{{ _priceWithoutDiscount | currency
		: "AUD"
		: "symbol-narrow"
		: "2.0" }}</span>
</div>
<div *ngIf="_value">
	<span class="sign" *ngIf="_negative">-</span>
	<span class="symbol">{{ _percentage ? "%" : "$" }}</span>
	<span class="value">{{ _value }}</span>
</div>
<div *ngIf="_totalCostAfterXMonths !== undefined">
	<span class="sign" *ngIf="_negative">-</span>
	<span class="symbol-totalCostAfterXMonths">{{ _percentage ? "%" : "$" }}</span>
	<span class="value-totalCostAfterXMonths">{{ _totalCostAfterXMonths }}</span>
</div>
